<template>
  <b-container>
    <div class="create-job-page page">
      <div class="page__header">
        <h2>Post a Tool</h2>
      </div>
      <div class="page__card mt-0">
        <div class="page__card__content page__card__content--lg">
          <job-form v-if="user" />
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Create Job/Tool page
 * ==================================================================================
 **/

import { mapState, mapMutations } from 'vuex'
import JobForm from '@/components/forms/JobForm'

export default {
  metaInfo: function() {
    return {
      title: 'Post a Tool'
    }
  },
  components: {
    JobForm
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    ...mapMutations({
      clearJobDetails: 'job/clearJobDetails'
    })
  },
  created() {
    this.clearJobDetails()
  }
}
</script>
<style scoped lang="scss">
.create-job-page {
}
</style>
